<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>上位：{{ limit }}位まで</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    limit: {
      type: Number,
      default: 1,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
